import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";

export default function LegalPage({ title, sections }) {
  return (
    <div className="min-h-screen bg-[#0B1B2F] text-neutral-100" data-testid="legal-page">
      <div className="max-w-3xl mx-auto px-6 md:px-10 py-10">
        <Link to="/" className="text-sm text-neutral-400 hover:text-neutral-100 inline-flex items-center gap-1">
          <ArrowLeft className="w-3 h-3"/> Voltar ao início
        </Link>
        <div className="flex items-center gap-3 mt-4 mb-6">
          <img src="/hermes-wing.png" alt="" className="w-10 h-10 object-contain"/>
          <div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#D9BF82]">HERMES</div>
            <h1 className="font-heading text-3xl">{title}</h1>
          </div>
        </div>
        <div className="prose prose-invert max-w-none">
          {sections.map((s, i) => (
            <section key={i} className="mb-6">
              <h2 className="font-heading text-xl text-[#E6C866] mb-2">{s.title}</h2>
              <div className="text-sm text-neutral-300 leading-relaxed whitespace-pre-wrap">{s.body}</div>
            </section>
          ))}
        </div>
        <div className="mt-10 pt-6 border-t border-white/10 text-xs text-neutral-500 flex items-center gap-2">
          <ShieldCheck className="w-3 h-3 text-[#D9BF82]"/> Última atualização: setembro de 2026
        </div>
      </div>
    </div>
  );
}

export function Privacidade() {
  return (
    <LegalPage title="Política de Privacidade"
      sections={[
        { title: "1. Coleta de dados",
          body: "O HERMES coleta apenas os dados necessários à prestação do serviço (nome, e-mail, dados profissionais do escritório e dos processos vinculados). Nenhum dado sensível é coletado sem consentimento expresso." },
        { title: "2. Uso das informações",
          body: "Os dados são usados exclusivamente para automatizar rotinas jurídicas, gerar relatórios oficiais e alertas de prazo. Nunca compartilhamos dados com terceiros para fins comerciais." },
        { title: "3. Segurança e LGPD",
          body: "Os dados são armazenados criptografados em repouso e em trânsito (TLS 1.3). Estamos em conformidade com a Lei Geral de Proteção de Dados (LGPD, Lei 13.709/2018). Você pode solicitar exportação ou exclusão dos seus dados a qualquer momento pelo e-mail delpadrestudio@gmail.com." },
        { title: "4. Fontes públicas",
          body: "As consultas oficiais realizadas pelo HERMES (DataJud/CNJ, CGU Portal da Transparência, RFB via BrasilAPI, PGFN Dívida Ativa, dentre outras) usam apenas dados públicos oficiais. O HERMES não inventa nem enriquece dados: se a fonte não responde, o sistema retorna SOURCE_UNAVAILABLE." },
        { title: "5. Cookies e sessão",
          body: "Utilizamos cookie de sessão (HTTP-only, Secure) apenas para manter o usuário logado. Não usamos cookies de rastreamento ou marketing." },
        { title: "6. Direitos do titular",
          body: "Nos termos da LGPD, você tem direito à confirmação do tratamento, acesso, correção, anonimização, portabilidade e exclusão dos dados. Envie sua solicitação por e-mail e responderemos em até 15 dias úteis." },
      ]}/>
  );
}

export function Termos() {
  return (
    <LegalPage title="Termos de Uso"
      sections={[
        { title: "1. Aceitação",
          body: "Ao acessar o HERMES, você concorda com estes Termos e com a Política de Privacidade. Se não concorda, não use o serviço." },
        { title: "2. Escopo do serviço",
          body: "O HERMES é uma plataforma de tecnologia jurídica que automatiza rotinas do escritório (prazos, publicações DJEN, cálculos, jurimetria, consultas oficiais). O serviço não substitui a análise técnica do advogado — o profissional é sempre o responsável final por qualquer decisão." },
        { title: "3. Uso responsável",
          body: "É proibido: (a) usar o HERMES para atividades ilícitas; (b) tentar acessar dados de outros escritórios; (c) revender consultas oficiais sem contrato específico; (d) submeter identificadores inválidos ou fraudulentos." },
        { title: "4. Cobrança e cancelamento",
          body: "Assinaturas mensais (Processo Watch, etc.) são cobradas via Stripe. Você pode cancelar a qualquer momento na página de Watches, sem prorrogação de cobrança. Consultas avulsas (Timeline, Compliance 360, CNPJ 360) são pagas por consumo." },
        { title: "5. Limitação de responsabilidade",
          body: "O HERMES entrega dados oficiais das fontes governamentais. Não somos responsáveis pela indisponibilidade das fontes originais (DataJud, CGU, RFB, PGFN). Em caso de SOURCE_UNAVAILABLE, o relatório é devolvido sem cobrança da consulta." },
        { title: "6. Alterações",
          body: "Estes Termos podem ser atualizados. Notificaremos você por e-mail com pelo menos 30 dias de antecedência antes de qualquer mudança relevante." },
      ]}/>
  );
}
